import React, { Component } from "react";

class EnsaCardPageBreak extends Component {
    render() { 
        require("./Ensa.css");
        const { title, children, isBreak } = this.props;
        return (
            <div className="cardLine" style={{display: 'flex', pageBreakAfter: isBreak ? 'always' : ''}}>
                <div className="card-section">
                    <div className="content">
                        <div className="title">
                            <h1 >{title}</h1>
                        </div>
                        {children}
                    </div>
                </div>
            </div>
        );
    }
}
 
export default EnsaCardPageBreak;